import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { StoreId } from "../../../../types";
import image from "../../assets/wifi/outdoor/u7-pro-outdoor.png";
import type { Product } from "../../types";
import { wifiOutdoor } from "../product-list-groups/wifi-outdoor";

export const u7proOutdoor: Product = {
  id: "u7proOutdoor",
  productTitle: "U7 Pro Outdoor",
  techspecsPath: [SiteId.TechSpecs, `/unifi/wifi/u7-pro-outdoor-us`],
  productListGroup: wifiOutdoor,
  storePathParts: (storeId: StoreId) => {
    const category = "wifi-outdoor";

    switch (storeId) {
      case StoreId.Us:
      case StoreId.Ca:
        return { productSlug: "u7-pro-outdoor-us", category };
      default:
        return { productSlug: "u7-pro-outdoor", category };
    }
  },
  isNew: true,
  sku: "U7-Pro-Outdoor",
  description: "u7proOutdoor.description",
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          'Without mount: 170 x 208 x 66.5 mm\n(6.7 x 8.2 x 2.6")\n\n\nWith mount: 170 x 208 x 121.8 mm\n(6.7 x 8.2 x 4.8")',
      },
    },
    {
      propertyId: "wifiTechnology",
      value: {
        type: "translation",
        value: "u7proOutdoor.wifiTechnology",
      },
    },
    {
      propertyId: "radio6Ghz",
      value: { type: "boolean", value: true, asterisk: 1 },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: true, asterisk: 1 },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "u7proOutdoor.antennaType.1",
        asterisk: 2,
      },
    },
    {
      propertyId: "coverage",
      value: {
        type: "translation",
        value: "u7proOutdoor.wifiCoverage",
      },
    },
    {
      propertyId: "connectedDevices",
      value: { type: "string", value: "300+" },
    },
    {
      propertyId: "externalAntennaSupport",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: "uplink",
      value: { type: "string", value: "2.5 GbE" },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.wallPole",
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "string", value: "IP67" },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["u7proOutdoor.notes.1", "u7proOutdoor.notes.2"],
};
